import { Typography } from "@mui/material";
import React from "react";
import { LOCALE } from "../../utils/locale";

export const ErrorComponent = ({ error }: any): React.ReactElement => {
  return (
    <Typography variant="h6">{`${LOCALE.errorOccurred}: ${error.errorCode}`}</Typography>
  );
};
